import { render, staticRenderFns } from "./install-orders.vue?vue&type=template&id=7150c02a"
import script from "./install-orders.vue?vue&type=script&lang=js"
export * from "./install-orders.vue?vue&type=script&lang=js"
import style0 from "./install-orders.vue?vue&type=style&index=0&id=7150c02a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports